import type { EmailVariable } from '../types'

/**
 * Build a {key -> example value} map from the template's variable contract,
 * so the live preview can substitute merge-tags with realistic sample data.
 *
 * Fallback order: `example` → `label` → `key`.
 */
export function buildMockVariableValues(
    variables: EmailVariable[] | undefined,
): Record<string, string> {
    const out: Record<string, string> = {}
    for (const v of variables || []) {
        out[v.key] = v.example || v.label || v.key
    }
    // Helpful common defaults we often see in tagada templates but merchants
    // frequently forget to seed with an example.
    const defaults: Record<string, string> = {
        customerFirstName: 'Alex',
        customerLastName: 'Morgan',
        customerEmail: 'alex@example.com',
        storeName: 'Your Store',
        storeUrl: 'https://yourstore.com',
        cartTotal: '$59.00',
        orderTotal: '$59.00',
        orderNumber: 'TGD-10238',
        checkoutUrl: 'https://yourstore.com/checkout',
        promotionCode: 'SAVE10',
        discountAmount: '$10.00',
    }
    for (const [k, v] of Object.entries(defaults)) {
        if (out[k] === undefined) out[k] = v
    }
    return out
}
